import { render } from "./OrganizationSettings.vue?vue&type=template&id=256029ae"
import script from "./OrganizationSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationSettings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Settings/OrganizationSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "256029ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('256029ae', __exports__)) {
    api.reload('256029ae', __exports__)
  }
  
  module.hot.accept("./OrganizationSettings.vue?vue&type=template&id=256029ae", () => {
    api.rerender('256029ae', render)
  })

}


export default __exports__